<template>
    <div class="obrazec obnova ovoj" id="html">
        <div class="glava">
            <div class="levi-logo">
              <img src='~@/assets/ikc.png'/>
            </div>
            <div class="desni-info">
                <p>Pivola 8, SI2311 Hoče</p>
                <p>Tel.: (02) 613 08 31, -32</p>
                <p>info@ikc-um.si</p>
                <p><a href="www.ikc-um.si">www.ikc-um.si</a></p>
            </div>
        </div>
        
        <div id="vsebina">
          
            <!--
            <div class="form-group">
                <div class="km-widget km-buttongroup k-widget k-button-group">
                <button  type="button" class="k-button k-primary" @click="saveData" :disabled="!saveEnabled" >Shrani</button>
                <button type="button" class="k-button k-primary" @click="nazaj" >Nazaj</button>
            </div>
            Shrani
            -->
        
            <div class="sekcija imeobrazca">
                <h1>Obnova prijave postopka certificiranja ekološkega kmetijskega gospodarstva (KMG)</h1>
                <h6>v skladu z veljavno zakonodajo za ekološko kmetijstvo</h6>
            </div> 

            <form @submit.prevent="handleSubmit" class="k-form">
            
                <div class="sekcija podatki">
                    <h1>1. OSNOVNI PODATKI O NOSILCU KMG</h1>

                    <fieldset >

                        <label for="nosilec" class="k-form-field">
                            <span>a) Nosilec KMG:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" v-model="nosilec" name="nosilec" id="nosilec" class="k-textbox" />
                        </div>
                        
                        <label for="ooseba" class="k-form-field">
                            <span>b) Odgovorna oseba nosilca:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" v-model="ooseba"  name="ooseba" id="ooseba" class="k-textbox" />
                        </div>
                        
                        <label for="naslov" class="k-form-field">
                            <span>c) Naslov:</span>
                        </label>
                        <div class="display-flex">
                                <input type="text" v-model="naslov"  name="naslov" id="naslov" class="k-textbox" />
                        </div>
                        
                        <label for="posta" class="k-form-field">
                            <span>d) Poštna številka in pošta:</span>
                        </label>
                        <div class="display-flex posta">
                            <input type="text" v-model="postnastevilka"  name="postnastevilka" id="postnastevilka" class="k-textbox " />
                            <input type="text" v-model="posta"  name="posta" id="nosipostalec" class="k-textbox" />
                        </div>
                        
                        <label for="kmgmid" class="k-form-field">
                            <span>e) KMG-MID:</span>
                        </label>
                            <div class="display-flex">
                            <input type="text" v-model="kmgmid"  name="kmgmid" id="kmgmid" class="k-textbox" />
                        </div>
                        
                        <label for="telefon" class="k-form-field">
                            <span>f) Telefon:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" v-model="telefon"  name="telefon" id="telefon" class="k-textbox" />
                        </div>
                        
                        <label for="mobitel" class="k-form-field">
                            <span>g) Mobilni telefon:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" v-model="mobitel"  name="mobitel" id="mobitel" class="k-textbox" />
                        </div>
                        
                        <label for="email" class="k-form-field">
                        <span>h) Elektronski naslov:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" v-model="email"  name="email" id="email" class="k-textbox" />
                        </div>
                        
                        <label for="spletnastran" class="k-form-field">
                            <span>i) Spletna stran KMG:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" v-model="spletnastran"  name="spletnastran" id="spletnastran" class="k-textbox" />
                        </div>
                        
                        <label for="naslovkmg" class="k-form-field">
                            <span>j) Naslov KMG:</span>
                        </label>
                        <div class="display-flex">
                                <input type="text" v-model="naslovkmg"  name="naslovkmg" id="naslovkmg" class="k-textbox" />
                        </div>
                        
                        <label for="postakmg" class="k-form-field">
                            <span>k) Poštna številka in pošta KMG:</span>
                        </label>
                        <div class="display-flex posta">
                            <input type="text" v-model="postnastevilkakmg"  name="postnastevilkakmg" id="postnastevilkakmg" class="k-textbox" />
                            <input type="text" v-model="postakmg"  name="postakmg" id="postakmg" class="k-textbox" />
                        </div>
                        
                        <label for="dopolnilnadejavnost" class="k-form-field">
                            <span>l) Dopolnilna dejavnost na kmetiji:</span>
                        </label>
                        <div class="display-flex ">
                            <input class="k-checkbox" v-model="dopolnilnadejavnost"  type="checkbox" name="dopolnilnadejavnost" value="da" id="dopolnilnadejavnostda">
                            <label class="form-check-label" for="dopolnilnadejavnostda" >
                            Da
                            </label>
                            <input class="k-checkbox" v-model="dopolnilnadejavnost"  type="checkbox" name="dopolnilnadejavnost"  value="ne" id="dopolnilnadejavnostne">
                            <label class="form-check-label" for="dopolnilnadejavnostne" >
                            Ne
                            </label>
                        </div>
                       

                        <label for="nazivdopolnilnadejavnost" class="k-form-field">
                            <span>m) Naziv nosilca dopolnilne dejavnosti na KMG (če je drugačen kot v a):</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" v-model="nazivdopolnilnadejavnost"  name="nazivdopolnilnadejavnost" id="mobinazivdopolnilnadejavnost" class="k-textbox" />
                        </div>
                        
                        <label for="davcnastevilka" class="k-form-field">
                            <span>n) Davčna številka nosilca KMG:</span>
                        </label>
                        <div class="display-flex">
                            <input type="text" v-model="davcnastevilka"  name="davcnastevilka" id="davcnastevilka" class="k-textbox" />
                        </div>
                        
                    </fieldset>

                </div>
                    <div class="firstpagespace"></div>
                 <div class="sekcija dejavnosti">
                    <h1>2. DEJAVNOSTI, ki jih prijavljate v postopek certificiranja </h1>

                    <fieldset class="">
                    <div class="seznamdejavnosti">
                         <template v-for="vrsta in vrsta">
                            <div :key="vrsta.id" style="break-inside: avoid;">
                            <input class="k-checkbox" v-model="vrstapridelovalca" :true-value="vrsta.id"  type="checkbox" :value="vrsta.id" :id="'vrsta_chk_'+vrsta.id">
                            <label class="form-check-label" :for="'vrsta_chk_'+vrsta.id" >
                            {{vrsta.naziv}}
                            </label>
                            </div>
                        </template>
                    </div>

                    </fieldset>
                </div>

                <div class="sekcija kategorije">
                    <h1>3. KATEGORIJE PROIZVODOV, ki jih prijavljate v postopek certificiranja</h1>

                    <fieldset class="">
                    <div class="seznamkategorij">
                         <template v-for="kategorija in kategorije">
                            <div :key="kategorija.id" style="break-inside: avoid;">
                            <input  class="k-checkbox" v-model="kategorijepridelovalca"  type="checkbox" :value="kategorija.id" :id="'kat_chk_'+kategorija.id">
                            <label class="form-check-label" :for="'kat_chk_'+kategorija.id" >
                            ({{kategorija.id}}) {{kategorija.naziv}}
                            </label>
                            </div>
                        </template>
                         <div>Proizvodi iz kategorije g:</div>
                            <fieldset class="">
                            <textarea rows="2" style="width:100%;" :value="proizvodi.filter(i=>i.status!='Neekološki'&&i.kategorija=='g').map(i=>i.naziv).join(', ')"></textarea>
                    </fieldset>

                    </div>

                    </fieldset>
                </div>

                <div class="sekcija posebnosti">
                    <h1>4. POSEBNOSTI</h1>

                    <fieldset class="">
                    <div class="seznamkategorij">
                         <template v-for="posebnost in posebnosti">
                            <div :key="posebnost.id" style="break-inside: avoid;">
                            <input  class="k-checkbox"  type="checkbox" :value="posebnost.id" :id="'pos_chk_'+posebnost.id">
                            <label class="form-check-label" :for="'pos_chk_'+posebnost.id" >
                            {{posebnost.naziv}}
                            </label>
                            </div>
                        </template>
                         <div>Drugo:</div>
                    <fieldset class="">
                    <textarea rows="1" style="width:100%;"></textarea>
                    </fieldset>
                    </div>
                    
                    <div class="seznamkategorij">
                        <div>BLAGOVNE ZNAMKE</div>
                         <template v-for="bz in blagovneznamke">
                            <div :key="bz.id" style="break-inside: avoid;">
                            <input  class="k-checkbox"  type="checkbox" :value="bz.id" :id="'bz_chk_'+bz.id">
                            <label class="form-check-label" :for="'bz_chk_'+bz.id" >
                            {{bz.naziv}}
                            </label>
                            </div>
                        </template>
                        <div>Drugo:</div>
                    <fieldset class="">
                    <textarea rows="1" style="width:100%;"></textarea>
                    </fieldset>
                    </div>
                    <div class="seznamkategorij">
                        <div>IZVAJANJE DEJAVNOSTI ZA TRETJE OSEBE NA KMG (uslužnostna predelava npr. mletje, luščenje, skladiščenje…)</div>
                         <template v-for="to in tretjeosebe">
                            <div :key="to.id" style="break-inside: avoid;">
                            <input  class="k-checkbox"  type="checkbox" :value="to.id" :id="'to_chk_'+to.id">
                            <label class="form-check-label" :for="'to_chk_'+to.id" >
                            {{to.naziv}}
                            </label>
                            </div>
                        </template>
                    </div>

                    </fieldset>
                </div>
<!--
                 <div class="sekcija kulture">
                    <h1>5. Kulture</h1>
                    <div>IKC UM bo upošteval prijavo površin in kultur po oddani zbirni vlogi v tekočem letu in izpisa površin iz registra kmetijskih gospodarstev.</div>
                    <div>
                        <input type="text" :value="kulture.filter(i=>i.status!='Neekološki').map(i=>i.naziv).join(' ,')"  name="proizvodi" id="proizvodi" class="k-textbox " />
                    </div>
                    

                </div>

                 <div class="sekcija proizvodi">
                    <h1>6. PREDELANI PROIZVODI IN ŽIVALSKI IZDELKI (mleko, jajca, meso…) </h1>
                    <div>Prijava novih proizvodov:</div>
                    <fieldset class="">
                    <textarea rows="3" style="width:100%;" :value="proizvodi.filter(i=>i.status!='Neekološki').map(i=>i.naziv).join(' ,')"></textarea>
                    </fieldset>
                </div>

                 <div class="sekcija zivali">
                    <h1>7. ŽIVALI</h1>
                    <div>IKC UM bo upošteval stanje živali v aplikaciji VOLOS</div>
                    <div>Prijava novih živali:</div>
                    <fieldset class="">
                    <textarea :value="zivali.filter(i=>i.status!='Neekološki').map(i=>i.naziv).join(' ,')" rows="3" style="width:100%;"></textarea>
                    </fieldset>
                </div>

                <div class="sekcija neekolosko">
                    <h1>8. NEEKOLOŠKI DEL DEJAVNOSTI (PRIDELAVA/PREDELAVA/DRUGA DEJAVNOST)</h1>
                    <div>Prijava novih neekoloških dejavnosti:</div>
                    <fieldset class="">
                    <textarea rows="3" style="width:100%;" :value="[...kulture, ...zivali,...proizvodi].filter(i=>i.status=='Neekološki').map(i=>i.naziv).join(' ,')"></textarea>
                    </fieldset>
                </div>
-->
                <div class="sekcija spremmembe" style="break-inside: avoid;">
                    <h1>5. Spremembe na KMG</h1>
                    <!--<div>Na obrazcu označite in spremenite samo tiste podatke, ki se spreminjajo. Poljščine se posodabljajo z zbirno vlogo.</div>-->
                    <fieldset class="">
                    <textarea  rows="4" style="width:100%;"></textarea>
                    </fieldset>
                </div>

                <div class="sekcija izjava" style="break-inside: avoid;">
                    <h1>Izjava</h1>
                    <div>
                    Prijavitelj s podpisom obnove prijave dovoljujem, da IKC UM kot del vsebine prijave dodatno upošteva tudi podatke iz uradnih evidenc (RKG, VOLOS, EIRŽ, Registra pridelovalcev semen…) in podatke po oddani zbirni vlogi glede površin, kultur, živali, ter ostalih informacij vezanih na postopek certificiranja ekološkega kmetijstva.</div>
                    
                    <!--<div>Izvajalec dejavnosti ali skupina izvajalcev dejavnosti se zavezuje, da bo:</div>
                    <ul>
                            <li>osebju izvajalca nadzora za izvajanje nadzora in drugih uradnih nadzornih aktivnosti, v primeru zahteve, omogočil dostop do:
                                </li><li>opreme, prevoznih sredstev, prostorov in drugih lokacij pod njihovo odgovornostjo ter njihove okolice;
        </li><li>svojih računalniško podprtih informacijskih sistemov;
        </li><li>živali in blaga pod njihovo odgovornostjo;
        </li><li>svojih dokumentov in vseh drugih ustreznih informacij;
        </li><li>pomagal osebju pristojnih in nadzornih organov ter z njimi sodeloval pri opravljanju njihovih nadzornih nalog;
        </li><li>prevzel odgovornost za pošiljko, ki vstopa v Unijo, in bo brez odlašanja dal na voljo na papirju ali v elektronski obliki vse informacije o živalih in blagu;
        </li><li>zagotovil vsaj naslednje posodobljene podatke: svoj naziv in pravno obliko, vrsto dejavnosti, ki jih izvaja, vključno z dejavnostmi, ki jih izvaja s sredstvi komunikacije na daljavo, in lokacije pod njihovo odgovornostjo;
        </li><li>vodil evidenco za dokazovanje skladnosti z veljavno ekološko zakonodajo;
        </li><li>podal vse izjave in druga sporočila, ki so potrebna za uradni nadzor;
        </li><li>sprejel ustrezne praktične, previdnostne in čistilne ukrepe za zagotavljanje skladnosti z ekološko zakonodajo;
        </li><li>zagotovil in posodabljal popolni opis predelovalne enote za izvajanje ekološke dejavnosti oz. v primeru tveganja  tudi drugih povezanih enot;  
        </li><li>da bo nadzornemu organu ali izvajalcu nadzora posredovali vse potrebne informacije za izvajanje nadzora;
        </li><li>da bo na zahtevo nadzornega organa ali izvajalca nadzora predložili rezultate lastnih programov za zagotavljanje kakovosti;
        </li><li>da bo v primeru utemeljenega suma na neskladje, suma na neskladje, ki ga ni mogoče ovreči, ali potrjenega neskladja, ki vpliva na neoporečnost zadevnih proizvodov, pisno in brez nepotrebnega odlašanja obvestil kupce proizvodov ter si z nadzornim organom ali izvajalcem nadzora obvestil izvajalca nadzora v roku 3 dni ter z njim izmenjal zadevne informacije;
        </li><li>da bo v primeru zamenjave nadzornega organa ali izvajalca nadzora pristal na prenos nadzorne dokumentacije ali, v primeru prenehanja opravljanja ekološke pridelave, na to, da zadnji nadzorni organ ali izvajalec nadzora pet let hrani nadzorno dokumentacijo;
        </li><li>da bo v primeru prenehanja opravljanja ekološke pridelave nemudoma obvestil nadzorni organ ali izvajalca nadzora;
        </li><li>da bo v primeru, da podizvajalce izvajalcev dejavnosti ali skupin izvajalcev dejavnosti nadzorujejo različni nadzorni organi ali izvajalci nadzora, pristal na izmenjavo informacij med temi nadzornimi organi ali izvajalci nadzora;
        </li><li>da bo dejavnosti izvajal v skladu s pravili ekološke pridelave;
        </li><li>da bo v primeru neskladij pristal na izvrševanje popravljalnih ukrepov, ki jih določi nadzorni organ ali izvajalec nadzora.
        </li></ul>-->
                </div>

                   <div class="sekcija podpis">
                    <div>S svojim podpisom potrjujem pravilnost in resničnost vpisanih podatkov.</div>
               
                     <div class="display-flex vrsticapodpisa">
                          <div><label for="datum" class="k-form-field"><span>Datum</span></label></div>
                          <div><label for="podpis" class="k-form-field"><span>Podpis prijavitelja</span></label></div>
                    </div>
                        
                     <div class="display-flex vrsticapodpisa">
                            <input type="text" v-model="datum"  name="datum" id="datum" class="k-textbox " />
                            <input type="text" v-model="podpis"  name="podpis" id="podpis" class="k-textbox" />
                        </div>
                        
                </div>

                <div class="sekcija prejem">
                    <div>Izpolni IKC UM</div>
               
                     <div class="display-flex vrsticapodpisa">
                          <div><label for="datum" class="k-form-field"><span>Datum prejema obrazca</span></label></div>
                          <div><label for="podpis" class="k-form-field"><span>Pregled</span></label></div>
                    </div>
                        
                     <div class="display-flex vrsticapodpisa">
                            <input type="text" v-model="datum"  name="datum" id="datum" class="k-textbox " />
                            <input type="text" v-model="podpis"  name="podpis" id="podpis" class="k-textbox" />
                        </div>
                        
                </div>

            </form>
        </div>
        <!-- <div class="noga">
            <div class="info">IKC UM</div>
            <div class="stevilka-strani"></div>
        </div> -->
    </div>
</template>
<style scoped>

  h1,h2,h3{
    font-size:5mm;
    line-size:5mm;
  }

@media print {
.sekcija {
    break-inside: avoid!important;
        }
}

 label,textarea{
    break-inside: avoid !important;
     
 }
.glava{
    
    display:    flex ;
    flex-direction:     row ;
    justify-content:    space-between  ;

}
.levi-logo  {
   position:   running(obrazecLeviLogo); 
}  

.levi-logo img{
    height: 2cm;
  
}
.desni-info {
    position:   running(obrazecDesniInfo);
}

.desni-info p{
    
    margin: 0;
    font-size:  0.4cm;
    line-height:   0.4cm;
    text-align:     right   ;
}



 .noga {

    position:   running(obrazecNoga);
    font-size: 3mm ;
    line-height:5mm;
    display:    flex ;
    flex-direction:     row ;
    justify-content:    space-between;
}

 .stevilka-strani:before{
  content: "Obr 3.21/1, rev 02, 20.12.2022, stran " counter(page) " od " counter(pages);
}


label.k-form-field{
    font-weight:    bold;
    font-size:  0.8em;
    line-height:    0.8em;
    margin-top:2mm;
    margin-bottom:1mm;
}
.posta input:nth-child(1){
    flex-basis: 15%;
    margin-right: 3mm;

}
h6{
    font-size: 0.7em;
}

.sekcija {
    margin-top:5mm;
    border:   1px solid green;
    padding: 2mm;
}
.posebnosti .seznamkategorij
{
    border-bottom:  1px solid green;
}
.izjava ul{
    list-style-type: disc;
margin-top: 3mm;
margin-bottom: 3mm;
margin-left: 0;
margin-right: 0;
padding-left: 10mm;
}
.vrsticapodpisa div {
    flex-basis: 50%;
}
</style>

<script>



import { mapState, mapActions,mapMutations } from 'vuex'
import { Previewer} from 'pagedjs';
import Vue from 'vue';

export default {
    props: ["pridelovalecid"],
   data() {
        return {
            posebnosti:[{id:0,naziv:"sočasna ekološka in neekološka pridelava/reja/predelava"},{id:1,naziv:"gobe"},{id:2,naziv:"vzgoja sadik"},{id:3,naziv:"samonikle rastline"},{id:4,naziv:"čebele"},{id:5,naziv:"pridelava semena"}],
            blagovneznamke:[{id:1,naziv:"DEMETER"},{id:2,naziv:"V-Label"},{id:3,naziv:"brez GSO"}],
            tretjeosebe:[{id:1,naziv:"Samo eko predelava"},{id:2,naziv:"samo konv. predelava"},{id:3,naziv:"eko in konv predelava"},],
            kulture:[],zivali:[],
            vrsta:[],
            status:[],
            pridelava:{},
            statuskategorije:[],
            kategorije:[],
            nosilec:"test",
            ooseba:"",
            naslov:"",
            posta:"",
            postnastevilka:"",
            kmgmid:"",
            telefon:"",
            mobitel:"",
            email:"",
            spletnastran:"",
            naslovkmg:"",
            postakmg:"",
            postnastevilkakmg:"",
            dopolnilnadejavnost:"",
            davcnastevilka:"",
            nazivdopolnilnadejavnost:""
        }
    },
    computed:{
      ...mapState({certifikat(state) {
      
          return state.certifikat.certifikat;
        }}),
       ...mapState('pridelava', ['pridelovalec']),
        ...mapState('sifrant', ['sifrant','dataSezone']),
        ...mapState({proizvodi(state) {
          return state.proizvod.proizvod;
        }}),
        

      kategorijepridelovalca:
        {
           get() {

            let kategorije=this.pridelava?.kategorije
              
                
            if (kategorije){
                return kategorije.map(i=>(i.id));
            }
            else
                return ["a"];

          },
        },
     vrstapridelovalca:
        {
           get() {

            let dejavnost=this.pridelava?.dejavnosti
                  console.log("getting dej")
                console.log(this.pridelava)
            if (dejavnost)
                return dejavnost.map(i=>(i.id));
            else
                return [];

          }
        },
 vrstapridelovalcavse:
        {
           get() {

            let pridelava=this.pridelovalec?.sheme?.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

            if (pridelava)
                return pridelava.vsedejavnosti;
            else
                return [];

          }
        },
        proizvodi:
        {
           get() {
            if(!this.certifikat.vsiproizvodi)
              return [];
            else
              return this.certifikat.vsiproizvodi.filter(i=>i.statuspridelkanaziv!='Neekološki').sort(
                (a,b)=>
                {
                  var x=a.vrstapridelkaid-b.vrstapridelkaid;
                  if(x)
                  return x;
                  else
                  {

                    return a.certifikat.localeCompare(b.certifikat);
                  }
                });
            
          },
        }
    
    },
     methods: {

        ...mapActions('certifikat', ['vrniPoId']),
          ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapActions('pridelava',['loadOne','save','loadIdPoSezoni']),
        ...mapActions('proizvod', ['load','save','loadPreteklaSezona']),
         ...mapMutations('pridelava',['updateprop','updateshemaprop']),
                handleSubmit(e){

          e.preventDefault();
        },
        print() {
                let paged = new Previewer();
                paged.preview();
        },
        naloziPodatke (){

         var thisComp=this;
        this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"vrstapridelovalca"}).then(()=>{
            thisComp.vrsta=thisComp.sifrant["vrstapridelovalca"];
                    this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"statuspridelovalca"}).then(()=>{
                    thisComp.status=thisComp.sifrant["statuspridelovalca"];
                     this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"kategorije"}).then(()=>{
                     thisComp.kategorije=thisComp.sifrant["kategorije"];

                     this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(p=>{

                            console.log(p);
                            thisComp.kmgmid=p.kmgmid;

                            thisComp.nosilec=p.kontakt[0].naziv;
                           // thisComp.ooseba=p.kontakt[0].naziv;
                            thisComp.naslov=p.naslov;
                            thisComp.posta=p.posta;
                            thisComp.postnastevilka=p.postnastevilka;
                            thisComp.telefon=p.kontakt.find(i=>i.vloga=="kmetija (kmg)")?.telefon.join(";");
                            thisComp.email=p.kontakt.find(i=>i.vloga=="nosilec kmg")?.email.join(", ");
                            thisComp.mobitel=p.kontakt.find(i=>i.vloga=="nosilec kmg")?.telefon.join(", ");
                            thisComp.naslovkmg=p.kontakt.find(i=>i.vloga=="kmetija (kmg)")?.naslov;
                            thisComp.postakmg=p.kontakt.find(i=>i.vloga=="kmetija (kmg)")?.posta
                            thisComp.postnastevilkakmg  =p.kontakt.find(i=>i.vloga=="kmetija (kmg)")?.postnastevilka;
                            thisComp.davcnastevilka =p.davcnastevilka  ;


                          let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");
                            if (pridelava) {
                            console.log("nastavim status kategorije");
                            console.log(pridelava.kategorije);
                            thisComp.pridelava  =pridelava  ;

                            }

                        this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled,vrsta:"kultura"}).then(

                                data=>{
                                    console.log("loading kulture!")
                                    thisComp.kulture=data.map(i=>{return {naziv:i.naziv,status:i.statuspridelkanaziv,vrsta:"kultura"}})
                                    
                                },
                                error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
                        );
                        this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled,vrsta:"zival"}).then(

                                data=>{
                                    console.log("loading kulture!")
                                    thisComp.zivali=data.map(i=>{return {naziv:i.naziv,status:i.statuspridelkanaziv,vrsta:"zival"}})
                                    
                                },
                                error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
                        );
                        this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled,vrsta:"proizvod"}).then(

                                data=>{
                                    console.log("loading kulture!")
                                    thisComp.proizvodi=data.map(i=>{return {naziv:i.naziv,status:i.statuspridelkanaziv,vrsta:"proizvod",kategorija:i.kategorija}})
                                    
                                //this.$nextTick(function () {
                                    //let paged = new Previewer();
                                    //paged.preview();
                                //});
                                },
                                error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
                        );



                            

                }) ;
      
        


        });
        });

        });

        
    }                
    

      },
    created()
  {
    
    if(!this.sezona)
        this.dataSezona={sezona:2022};
    else
      this.dataSezona={sezona:this.sezona};

     this.naloziPodatke();
     //window.addEventListener('beforeprint',this.print);
},

  mounted(){
   
 }
}
</script>